import PropTypes from 'prop-types';
import React from 'react';
import { getComponentClasses } from '@99designs/common/utils/app';

const Drawer = ({ children, variations }) => (
    <div className={getComponentClasses('drawer', variations)}>
        <div className="drawer__inner">
            {React.Children.map(children, child => (
                <div className="drawer__item">{child}</div>
            ))}
        </div>
    </div>
);

Drawer.propTypes = {
    children: PropTypes.node.isRequired,
    variations: PropTypes.array,
};

Drawer.defaultProps = {
    variations: [],
};

export default Drawer;



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/entries/components/drawer.jsx